import { render, staticRenderFns } from "./ParticipantStatusBadge.vue?vue&type=template&id=59b24a14&scoped=true&"
import script from "./ParticipantStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ParticipantStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantStatusBadge.vue?vue&type=style&index=0&id=59b24a14&scoped=true&lang=css&"
import style1 from "./ParticipantStatusBadge.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b24a14",
  null
  
)

export default component.exports